<boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
</boi-validation-error-generic>

<kendo-textbox-container class="form-element">
  <div [ngClass]="cssClasses" class="field-container">
    <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined">
      <div class="label-content">
        <label
          [for]="controlId ? controlId : labelName"
          [innerHtml]="labelName | localizeLabel"
          *ngIf="labelName"
        ></label>
      </div>
      <boi-tooltip
        *ngIf="showTooltip && !isTooltipLast"
        [tooltipName]="tooltipName ? tooltipName : labelName"
      ></boi-tooltip>
    </div>

    <div class="field-input">
      <textarea
        *ngIf="!isFieldDisabled"
        [id]="controlId ? controlId : labelName"
        [(ngModel)]="value"
        [attr.maxLength]="maxLength"
        [placeholder]="placeholder"
        [required]="required"
        [readonly]="isReadonly"
        [rows]="rows"
        [pattern]="pattern"
        (blur)="onBlur()"
        kendoTextArea
      ></textarea>

      <div *ngIf="isFieldDisabled" class="k-textarea field-value-disable display-block" [innerHtml]="value"></div>
    </div>

    <div *ngIf="showCharsLimit" class="char-limit-container">
      <span class="char-limit-left">
        {{ referenceDataLabels.CharactersCounterLabel | localizeLabel | formatString : [maxLength] }}
      </span>
      <span class="char-limit-right"> {{ value?.length || 0 }}/{{ maxLength }} </span>
    </div>
  </div>

  <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
</kendo-textbox-container>
